export default __webpack_public_path__ + "static/media/dalenfront_thumb.f937fe59.jpg";